import { useMutation } from '@tanstack/react-query';
import { toast } from 'sonner';
import { useTranslation } from 'react-i18next';
import { useAuthContext } from '@/contexts/AuthContext';
import { atualizarMeuPerfil } from '@/services/profiles.service';
import { sanitizeSupabaseError } from '@/lib/errorHandler';

export interface DadosPessoaisInput {
  telefone: string | null;
  morada: string | null;
  codigoPostal: string | null;
  cidade: string | null;
  pais: string | null;
}

/**
 * Mutação dos dados pessoais (telefone + endereço). Após sucesso refresca o
 * profile no AuthContext para refletir em todo o lado sem reload.
 */
export function useDadosPessoais() {
  const { t } = useTranslation();
  const { refreshProfile } = useAuthContext();

  const mutation = useMutation({
    mutationFn: (dados: DadosPessoaisInput) => atualizarMeuPerfil(dados),
    onSuccess: async () => {
      await refreshProfile();
      toast.success(t('personalDataForm.savedToast'));
    },
    onError: (error) => toast.error(sanitizeSupabaseError(error)),
  });

  return {
    salvar: (dados: DadosPessoaisInput) => mutation.mutate(dados),
    isSaving: mutation.isPending,
  };
}
